import SrOnlyText from './SrOnlyText';

export default SrOnlyText;
